import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Button } from '@vnetwork/ui/primitives';
import { usePartnerContracts } from '@/api/contracts';
import { ContractListSection } from './components/contract-list-section';
import { partnerContractColumns } from './list-configs/contract-column-definitions';
import { partnerContractFilters } from './list-configs/contract-filter-fields';

/**
 * Partner Contracts — the ported buy-side (supplier) contract list. Same
 * server-paginated `ContractListSection` pattern as the customer list, driven by
 * `usePartnerContracts`, with a status filter and `q` search. No stat band and
 * no row navigation yet (partner detail route not built) — the contract number
 * renders as plain text.
 */
export default function PartnerContractsPage() {
  const navigate = useNavigate();

  return (
    <Container size="full">
      <PageHeader
        title="Partner Contracts"
        description="Supplier (buy-side) contracts — procurement agreements with partners."
        style={{ marginBottom: 'var(--vn-space-4)' }}
        actions={
          <Button
            variant="secondary"
            startIcon={<ArrowLeft size={15} />}
            onClick={() => navigate('/contracts')}
          >
            Customer contracts
          </Button>
        }
      />

      <ContractListSection
        useListQuery={usePartnerContracts}
        columns={partnerContractColumns}
        getRowId={(r) => String(r.contract_id)}
        filterFields={partnerContractFilters}
        searchPlaceholder="Search partner contracts…"
        errorTitle="Failed to load partner contracts"
        emptyTitle="No partner contracts found"
      />
    </Container>
  );
}
